import { render, staticRenderFns } from "./PrivacyMatchTheRunes.vue?vue&type=template&id=6d862bec&scoped=true"
import script from "./PrivacyMatchTheRunes.vue?vue&type=script&lang=js"
export * from "./PrivacyMatchTheRunes.vue?vue&type=script&lang=js"
import style0 from "./PrivacyMatchTheRunes.vue?vue&type=style&index=0&id=6d862bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d862bec",
  null
  
)

export default component.exports